import React from 'react'

import { I18n } from 'react-redux-i18n'

export interface Props {
  messageKey: string
  options?: any
  onAction?: () => void
}

const TradeToast = ({ messageKey, options, onAction }: Props) => {
  return <div onClick={onAction}>{I18n.t(messageKey, options)}</div>
}

export default TradeToast
